/**
 *  Define a token for the validators
 */
export const ValidateToken = 'ValidateToken';
